<template>
  <div>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="usersList"
        :search="search"
        class="elevation-1 pb-3"
        :loading="loading"
        :loading-text="$t('loadingData')"
        :no-data-text="$t('noDataText')"
        :no-results-text="$t('noResultsText')"
        :items-per-page="100"
        hide-default-footer
      >
        <template v-slot:top>
          <div class="row no-gutters d-flex align-center pa-3">
            <div class="d-flex align-center" v-if="usersList.length > 0">
              <v-icon left>mdi-account-multiple</v-icon>
              <span>{{ totalPlayers }}</span>

              <span class="ml-2">
                {{ $tc("usersPlurals", totalPlayers) }}
              </span>

              <v-progress-circular
                v-if="fetchingPlayers"
                indeterminate
                :size="20"
                color="primary"
                class="ml-2"
              ></v-progress-circular>
            </div>
            <v-spacer />
            <v-col cols="12" md="4" sm="4">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </div>
        </template>
  
        <template v-slot:[`item.id`]="{ item }">
          <v-btn @click="$copy(item.id)" x-small>
            {{ item.id }}
          </v-btn>
        </template>

        <template v-slot:[`item.status`]="{ item }">
          <v-chip small :color="handleStatus(item.status).color">
            {{ handleStatus(item.status).text}}
          </v-chip>
        </template>
  
        <template v-slot:[`item.register_date`]="{ item }">
          {{ handleDateFormat(item.register_date).date }}
        </template>
  
        <template v-slot:[`item.last_login`]="{ item }">
          {{ handleDateFormat(item.last_login).date }}
        </template>
        <template v-slot:[`item.schedule`]="{ item }">
          {{ handleDateFormat(item.last_login).hour }}
        </template>
      </v-data-table>
      <v-pagination
        v-if="pageCount > 0 && usersList.length > 0"
        v-model="page"
        :length="pageCount"
        :total-visible="7"
        class="py-3"
      ></v-pagination>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "relatorio-usuarios",
  data: (vm) => ({
    loading: false,
    fetchingPlayers: false,
    page: 1,
    pageCount: 0,
    timeoutId: 0,
    cachedPage: {},
    search: "",
    totalPlayers: 0,
    headers: [
      { text: "ID", value: "id", align: "no-wrap" },
      { text: vm.$t("name"), value: "name", align: "no-wrap" },
      { text: "Status", value: "status", align: "no-wrap" },
      { text: vm.$t("dateRegistration"), value: "register_date", align: "no-wrap" },
      { text: vm.$t("schedule"), value: "schedule", align: "no-wrap" },
      { text: vm.$t("onlineBalance"), value: "balance_online", align: "no-wrap" },
      { text: vm.$t("amountOfDeposits"), value: "deposit_qty", align: "no-wrap" },
      { text: vm.$t("deposits"), value: "deposit_value", align: "no-wrap" },
    ],
    usersList: [],
    routeName: "",
  }),

  computed: {
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    rangeDate() {
      let { date_start, date_final } = this.$store.state.rangeGlobal.date;
      return { data_inicio: date_start, data_final: date_final };
    },
  },

  watch: {
    rangeDate() {
      this.debouncedFetchTotalPlayersByRange();
    },
    saveFilters(bool) {
      bool && this.playersReport();
    },
    page() {
      this.playersReport();
    },
    totalPlayers(players) {
      if (players == 0) {
        this.usersList = []; 
      }
    },
  },

  mounted() {
    this.debouncedFetchTotalPlayersByRange();
    this.routeName = this.$route.name;
  },

  methods: {
    debouncedFetchTotalPlayersByRange() {
      clearTimeout(this.timeoutId);
      const currentTimeout = setTimeout(()=> {this.fetchTotalPlayersByRange()}, 500);
      this.timeoutId = currentTimeout;
    },

    async fetchTotalPlayersByRange() {
      this.fetchingPlayers = true;
      const body = {
        ...this.rangeDate,
      }
      await this.$axios
        .post("agent/players/countTotalPlayersByRange", this.$formdata(body))
        .then((response) => {
          this.totalPlayers = Number(response.data.dados.total_players);
          this.pageCount = Math.ceil(this.totalPlayers / 100);
          this.fetchingPlayers = false;
        })
        .catch(() => this.fetchingPlayers = false);
    },

    async playersReport() {
      const currentRangeDate = this.rangeDate
      const body = {
        ...this.rangeDate,
        export: this.exportDoc,
      }

      if (this.exportDoc) {
        await this.$exportDocument(
          "agent/players/playerReport",
          body,
          this.exportDoc,
          this.rangeDate,
          this.routeName
        );
        return
      }

      body.page_number = this.page - 1;
      this.loading = true;
      this.usersList = []

      if (this.cachedPage[this.page] && currentRangeDate != this.rangeDate) {
        this.usersList = this.cachedPage[this.page]
        this.loading = false;
        return
      }

      await this.$request
        .post("agent/players/playerReport", body)
        .then((resp) => {
          this.usersList = resp.data.dados;
          this.cachedPage[this.page] = this.usersList;
          this.loading = false;
        })
        .catch(() => this.loading = false);
    },

    handleDateFormat(dateAndHour) {
      if (dateAndHour == null) {
        return { 
          date: "-",
          hour: "-"
        };
      } else {
        return { 
          date: new Date(dateAndHour).toLocaleDateString(),
          hour: new Date(dateAndHour).toLocaleTimeString()
        };
      }
    },

    handleStatus(status) {
      if (status == 1) return { text: this.$t("active"), color: "green"};
      if (status == 0) return { text: this.$t("suspended"), color: "red"};
      if (status == 5) return { text: this.$t("pending"), color: "grey"};
      if (status == 6) return { text: this.$t("blocked"), color: "red"};
      return { text: this.$t("disabled"), color: "grey" };
    },

    handleNullOrEmptyValues(value) {
      if (!value || value == "0") {
        return " ••• ";
      }

      if (value) {
        return value;
      } else {
        return " ••• ";
      }
    },
  }
}
</script>